import React, { Component } from "react";
import axios from "axios";
import { FaDownload } from "react-icons/fa";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "react-select";
import { getcyclelist } from "store/cycle/actions";

// import { Button } from "react-bootstrap";
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Row,
  Label,
  Modal,
  Input,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button, // ✅ Add this here
} from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import filterFactory from "react-bootstrap-table2-filter";
import Breadcrumbs from "components/Common/Breadcrumb";
import { getfinancialforecast } from "store/Payment/actions";
import "assets/scss/table.scss";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { add } from "lodash";

class ParticipantPayments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      schemeFilterSelected: false,
      nameFilter: "",
      districtFilter: "",
      cityFilter: "",
      provinceFilter: "",
      schemeFilter: "",
      schemeModalOpen: false,
      showReconcileModal: false,
      amountFilter: "",
      discountFilter: "",
      statusFilter: "",
      forecastType: null,
      pendingReconcileStatus: null,
      hoveredSchemeNames: [],
      CycleList: [],
      showReconcileDetailsModal: false,
      activeRowId: null,
      paymentConfirmState: {},
      filtersApplied: false,
      hoveredSchemeNames: [],
      selectedCheckboxes: {},
      tableKey: 0,
      filtersApplied: false, // Prevent data from loading by default
      GetFinancialForecast: [],
      feedbackMessage: "",
      errorMessage: "",
      paymentMethodFilter: "",
      reconcileStatusFilter: "",
      finalpayableFilter: "",
      paidamountFilter: "",
      remainingAmountFilter: "",
      membershipStatusFilter: "",
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      feedbackListColumns: [
        {
          dataField: "participant_name",
          text: "Participant Name",
          sort: true,
          headerStyle: {
            backgroundColor: "#87ceeb",
            textAlign: "center",
          },
          style: {
            textAlign: "left",
          },
          formatter: (cell, row) => (
            <span
              style={{ color: "#0d6efd", cursor: "pointer" }}
              onClick={() => this.openParticipantModal(row)}
            >
              {cell}
            </span>
          ),
          headerFormatter: (column) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  placeholder={column.text} // ✅ same as “Participant Name”
                  value={this.state.nameFilter}
                  onChange={(e) => this.handleFilterChange("nameFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "left",
                    width: "120px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },

        {
          dataField: "part_payment_amount",
          text: "Paid Amount",
          sort: true,
          headerStyle: {
            backgroundColor: "#87ceeb",
            textAlign: "center",
          },
          style: {
            // backgroundColor: "#87ceeb",
            textAlign: "right",
          },

          formatter: (cell, row) => {
            // ✅ Full payment case
            if (row.payment_settlement === "Full") {
              return this.formatNumber(row.price);
            }

            // ✅ Part payment case
            return this.formatNumber(cell);
          },

          headerFormatter: (column) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.paidamountFilter}
                  onChange={(e) =>
                    this.handleFilterChange("paidamountFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "70px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },

        {
          dataField: "status",
          text: "Status",
          sort: true,
          headerStyle: {
            backgroundColor: "#87ceeb",
            textAlign: "center",
          },
          style: {
            // backgroundColor: "#87ceeb",
            textAlign: "right",
          },

          headerFormatter: (column) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.statusFilter}
                  onChange={(e) => this.handleFilterChange("statusFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "70px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
      ],
      tableKey: Date.now(), // ✅ so you can force re-render
    };
  }
  formatNumber = (value, options = {}) => {
    const num = Number(value);
    return !num || num === 0
      ? "-"
      : num.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
        ...options,
      });
  };

  handleCheckboxToggle = (rowId) => {
    this.setState((prevState) => ({
      paymentConfirmState: {
        ...prevState.paymentConfirmState,
        [rowId]: {
          ...prevState.paymentConfirmState[rowId],
          checked: !prevState.paymentConfirmState[rowId]?.checked,
        },
      },
      tableKey: Date.now(), // trigger full re-render of table
    }));
  };
  handleFilterChange = (filterName, e) => {
    const value = e.target.value;

    this.setState(
      (prevState) => ({
        [filterName]: value,

        dateToActive: filterName === "dateTo" ? true : prevState.dateToActive,
      }),
      this.checkFiltersApplied,
    );
  };

  isValidFilter = (value) => {
    return value && value !== "Select" && value !== "All";
  };

  handleFilterChange = (filterName, e) => {
    const value = e.target.value;

    this.setState(
      (prevState) => ({
        [filterName]: value,

        dateToActive: filterName === "dateTo" ? true : prevState.dateToActive,
      }),
      this.checkFiltersApplied,
    );
  };
  handleFileChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue("photo", file);
  };

  handleCloseModal = () => {
    this.setState({
      showReconcileModal: false,
      activeRowId: null,
      activeParticipantName: "",
      selectedReconcileStatus: null,
    });
  };

  componentDidMount() {
    this.loadFiltersFromSession();
    const { ongetfinancialforecast, ongetcyclelist } = this.props;

    // Fetch user_id from localStorage
    const user_id = localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser")).user_id
      : "";

    // Dispatch actions with the required user_id
    ongetfinancialforecast();
    ongetcyclelist(user_id);
    window.addEventListener("beforeunload", this.saveFiltersToSession);
    // Add logging after API responses
    setTimeout(() => {
      console.log("Payments Fetched:", this.props.GetFinancialForecast); // Ensure account_number is included
    }, 1000); // Allow sagas to fetch and update the state
  }

  fetchData(user_id) {
    const { ongetfinancialforecast, ongetcyclelist } = this.props;

    // Call participant payment API
    ongetfinancialforecast();
    console.log("ongetfinancialforecast called with user_id:", user_id);

    // Call cycle list API
    ongetcyclelist(user_id);
    console.log("ongetcyclelist called with user_id:", user_id);
  }
  handleSchemeChange = (event) => {
    const selectedScheme = event.target.value;
    console.log("Scheme selected:", selectedScheme);

    this.setState({ selectedScheme }, () => {
      this.applyFilters(); // Call filters after updating state
    });
  };
  componentDidUpdate(prevProps) {
    const { GetFinancialForecast, CycleList } = this.props;

    if (CycleList !== prevProps.CycleList) {
      this.setState({ CycleList });
    }

    if (GetFinancialForecast !== prevProps.GetFinancialForecast) {
      const {
        current_new = [],
        old_new = [],
        old_current = [],
      } = GetFinancialForecast || {};

      const addCategory = (data, category) =>
        data.map((item) => ({
          ...item,
          category,
        }));

      const mergedData = [
        ...addCategory(current_new, "current_new"),
        ...addCategory(old_new, "old_new"),
        ...addCategory(old_current, "old_current"),
      ];

      this.setState({
        GetFinancialForecast: mergedData, // 🔥 store ALL data
      });
    }
  }

  handleSchemeClick = (row) => {
    // If there's any timeout still running from previous hover, clear it
    if (this.mouseExitTimeout) {
      clearTimeout(this.mouseExitTimeout);
    }

    // Open the modal with row data
    this.setState({
      hoveredSchemeNames: row.scheme_names || [],
      schemeModalOpen: true,
      hoveredParticipantName: row.participant_name || "",
    });
  };
  toggleEditModal = (row, participant = null) => {
    // 🧼 Normalize scheme names for matching
    const matchedSchemes =
      row?.scheme_names
        ?.map((name) => {
          const cleanedName = name.replace(/,/g, "").trim().toLowerCase();
          const found = this.state.CycleList?.find((option) => {
            const optionName = option.scheme_name
              .replace(/,/g, "")
              .trim()
              .toLowerCase();
            return optionName === cleanedName;
          });
          return found;
        })
        .filter(Boolean) || [];

    // 🪪 Format scheme IDs
    const scheme_ids = matchedSchemes.map(
      (opt) => `${opt.scheme_id}-${opt.id}`,
    );

    // 🧾 Debug final total
    console.log("✅ matchedSchemes:", matchedSchemes);

    this.setState({
      editModalOpen: true,
      selectedRow: row,
      selectedScheme: scheme_ids,
      selectedParticipant: participant || {
        name: row?.participant_name || "",
        district: row?.district || "",
        city: row?.city || "",
        province: row?.province || "",
        id: row?.participant || "",
      },
    });
  };
  handleSchemeModalClose = () => {
    this.setState({
      schemeModalOpen: false,
    });
  };

  checkFiltersApplied = () => {
    const {
      nameFilter,
      districtFilter,
      cityFilter,
      provinceFilter,
      schemeFilter,
      amountFilter,
      paidamountFilter,
      membershipStatusFilter,
    } = this.state;

    // Check if ANY filter is applied AND has a NON-EMPTY value
    const filters = [
      nameFilter,
      districtFilter,
      cityFilter,
      provinceFilter,
      schemeFilter,
      amountFilter,
      paidamountFilter,
      membershipStatusFilter,
    ];

    const anyFilterSelected = filters.some((f) => f && f.trim() !== "");

    this.setState({ filtersApplied: anyFilterSelected });
  };
  filterData = () => {
    const {
      GetFinancialForecast,
      nameFilter = "",
      districtFilter = "",
      cityFilter = "",
      provinceFilter = "",
      schemeFilter = "",
      paidamountFilter = "",
      forecastType,
    } = this.state;

    const isActive = (val) =>
      val !== undefined &&
      val !== null &&
      val !== "" &&
      val !== "All" &&
      val !== "Select";

    let dataToFilter = GetFinancialForecast || [];

    // Filter by scheme first
    if (isActive(schemeFilter) && schemeFilter !== "All") {
      dataToFilter = dataToFilter.filter((entry) => {
        return (
          entry.schemes?.some(
            (s) => s.scheme_name?.toLowerCase() === schemeFilter.toLowerCase(),
          ) ||
          entry.scheme_names?.some(
            (name) => name?.toLowerCase() === schemeFilter.toLowerCase(),
          )
        );
      });
    }

    // Filter by category (compare cycles)
    if (isActive(forecastType)) {
      dataToFilter = dataToFilter.filter((entry) => {
        const schemes = entry.schemes || [];

        switch (forecastType) {
          case "current_new":
            // Has paid in Previous of a scheme but NOT in New of that SAME scheme
            return schemes.some((s) => {
              const schemeId = s.scheme_id;
              const hasPrevious = schemes.some(
                (x) =>
                  x.scheme_id === schemeId && x.reportstatus === "Previous",
              );
              const hasNew = schemes.some(
                (x) => x.scheme_id === schemeId && x.reportstatus === "New",
              );
              return hasPrevious && !hasNew;
            });

          case "old_new":
            // Has paid in Old of a scheme but NOT in New of that SAME scheme
            return schemes.some((s) => {
              const schemeId = s.scheme_id;
              const hasOld = schemes.some(
                (x) => x.scheme_id === schemeId && x.reportstatus === "Old",
              );
              const hasNew = schemes.some(
                (x) => x.scheme_id === schemeId && x.reportstatus === "New",
              );
              return hasOld && !hasNew;
            });

          case "old_current":
            // Has paid in Old of a scheme but NOT in Previous of that SAME scheme
            return schemes.some((s) => {
              const schemeId = s.scheme_id;
              const hasOld = schemes.some(
                (x) => x.scheme_id === schemeId && x.reportstatus === "Old",
              );
              const hasPrevious = schemes.some(
                (x) =>
                  x.scheme_id === schemeId && x.reportstatus === "Previous",
              );
              return hasOld && !hasPrevious;
            });

          default:
            return true;
        }
      });
    }

    // Other filters: name, district, city, province, paid amount
    return dataToFilter.filter((entry) => {
      if (
        isActive(nameFilter) &&
        !entry.participant_name
          ?.toLowerCase()
          .includes(nameFilter.toLowerCase())
      )
        return false;

      if (
        isActive(districtFilter) &&
        !entry.district?.toLowerCase().includes(districtFilter.toLowerCase())
      )
        return false;

      if (
        isActive(cityFilter) &&
        !entry.city?.toLowerCase().includes(cityFilter.toLowerCase())
      )
        return false;

      if (
        isActive(provinceFilter) &&
        !entry.province?.toLowerCase().includes(provinceFilter.toLowerCase())
      )
        return false;

      if (
        isActive(paidamountFilter) &&
        !String(entry.part_payment_amount || "")
          .toLowerCase()
          .includes(paidamountFilter.toLowerCase())
      )
        return false;

      return true;
    });
  };
  getUniqueOptions = (fieldName) => {
    const { GetFinancialForecast } = this.state;
    const options = new Set();

    GetFinancialForecast.forEach((item) => {
      const value = item[fieldName];
      if (Array.isArray(value)) {
        value.forEach((v) => options.add(v));
      } else if (value) {
        options.add(value);
      }
    });

    return Array.from(options);
  };
  saveFiltersToSession = () => {
    const filtersToSave = {
      nameFilter: this.state.nameFilter,
      districtFilter: this.state.districtFilter,
      cityFilter: this.state.cityFilter,
      provinceFilter: this.state.provinceFilter,
      schemeFilter: this.state.schemeFilter,
      discountFilter: this.state.discountFilter,
      reconcileStatusFilter: this.state.reconcileStatusFilter,
      paidamountFilter: this.state.paidamountFilter,
      finalpayableFilter: this.state.finalpayableFilter,
      membershipStatusFilter: this.state.membershipStatusFilter,
    };

    // Save filters + origin flag
    sessionStorage.setItem("PaymentCSRFilters", JSON.stringify(filtersToSave));
    sessionStorage.setItem("cameFromScheme", "true");
  };

  loadFiltersFromSession = () => {
    const cameFromScheme = sessionStorage.getItem("cameFromScheme");
    const savedFilters = sessionStorage.getItem("PaymentCSRFilters");

    if (cameFromScheme && savedFilters) {
      this.setState(JSON.parse(savedFilters));
    }

    // Always clear the flag so filters aren't restored again after refresh
    sessionStorage.removeItem("cameFromScheme");
  };
  getVerifiedPaymentsForParticipant = () => {
    const { GetFinancialForecast, activeRowId } = this.state;

    // find active payment row
    const activePayment = GetFinancialForecast.find(
      (p) => p.id === activeRowId,
    );
    if (!activePayment) return [];

    return GetFinancialForecast.filter(
      (p) => p.participant_id === activePayment.participant_id,
    );
  };

  openParticipantModal = (row) => {
    const { forecastType, schemeFilter, GetFinancialForecast } = this.state;

    const allRowsForParticipant = GetFinancialForecast.filter(
      (r) => r.participant_id === row.participant_id
    );

    console.log("All rows for participant:", allRowsForParticipant);

    const allSchemes = [];
    const seen = new Set();

    allRowsForParticipant.forEach((r) => {
      (r.schemes || []).forEach((s) => {
        const key = `${s.scheme_id}-${s.reportstatus}`;
        if (!seen.has(key)) {
          seen.add(key);
          allSchemes.push(s);
        }
      });
    });

    console.log("All merged schemes:", allSchemes);

    // ✅ scheme_id se group karo
    const grouped = {};
    allSchemes.forEach((s) => {
      if (!grouped[s.scheme_id]) grouped[s.scheme_id] = [];
      grouped[s.scheme_id].push(s);
    });

    const formattedSchemes = Object.values(grouped)
      .map((group) => {
        const schemeName = group[0].scheme_name;
        const previousEntry = group.find((s) => s.reportstatus === "Previous");
        const oldEntry = group.find((s) => s.reportstatus === "Old");
        const newEntry = group.find((s) => s.reportstatus === "New");

        const cycleNo = (previousEntry || newEntry || oldEntry)?.cycle_no || "-";

        const anyEntry = previousEntry || oldEntry || newEntry;
        const unpaidCycleNo = anyEntry?.new_cycle_no || "-";

        return {
          schemeName,
          cycleNo,
          previous: previousEntry?.cycle_no || "-",
          old: oldEntry?.cycle_no || "-",
          newCycle: newEntry?.cycle_no || unpaidCycleNo,
          hasOld: !!oldEntry,
          hasPrevious: !!previousEntry,
          hasNew: !!newEntry,
        };
      })
      .filter((s) => {
        if (schemeFilter && schemeFilter !== "All" && schemeFilter !== "") {
          if (s.schemeName?.toLowerCase() !== schemeFilter.toLowerCase()) {
            return false;
          }
        }
        return true;
      });

    console.log("Formatted schemes for modal:", formattedSchemes);

    this.setState({
      showParticipantModal: true,
      selectedParticipant: row,
      modalSchemes: formattedSchemes,
      selectedCategory: forecastType,
    });
  };
  closeParticipantModal = () => {
    this.setState({
      showParticipantModal: false,
      selectedParticipant: null,
    });
  };

  render() {
    const schemeOptionsFromData = [
      ...new Set(
        (this.state.GetFinancialForecast || []).flatMap((row) =>
          (row.schemes || []).map((s) => s.scheme_name),
        ),
      ),
    ];

    const { GetFinancialForecast } = this.state;
    const defaultSorted = [{ dataField: "id", order: "desc" }];
    const filteredData = this.filterData();
    const { CycleList } = this.state;
    const { editModalOpen, selectedRow } = this.state;
    const schemeOptions = CycleList.map((scheme) => ({
      value: `${scheme.scheme_id}-${scheme.id}`,
      label: `(Scheme Name: ${scheme.scheme_name}) - (Cycle Number: ${scheme.cycle_no})`,
      scheme_id: scheme.scheme_id,
      cycle_id: scheme.id,
    }));
    const verifiedPaymentIds = this.getVerifiedPaymentsForParticipant().map(
      (p) => p.id,
    );

    const filteredSchemes = (this.state.activeRowSchemes || []).filter(
      () => !verifiedPaymentIds.includes(this.state.activeRowPaymentId),
    );

    console.log("CycleList:", CycleList);
    console.log("Generated schemeOptions:", schemeOptions);
    const participant = this.state.selectedParticipant;

    console.log("FULL participant object:", participant);

    // ✅ Use the backend-provided schemes array directly
    const schemes = participant?.schemes || [];
    const schemeCount = schemes.length;

    const pageOptions = {
      sizePerPage: 50,
      totalSize: filteredData.length,
      custom: true,
      page: 1,
    };
    const customStyles = {
      // <- This is invalid here
      control: (provided) => ({
        ...provided,
        minHeight: "38px",
      }),
    };
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Participant Payment | NHS NEQAS</title>
          </MetaTags>

          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs
              title="Labs"
              breadcrumbItem="Participant-Financial Report"
            />
            <Modal
              isOpen={this.state.showParticipantModal}
              toggle={this.closeParticipantModal}
            >
              <ModalHeader toggle={this.closeParticipantModal}>
                Schemes for {this.state.selectedParticipant?.participant_name}
              </ModalHeader>

              <ModalBody>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th style={{ textAlign: "center" }}>Scheme Name</th>
                     {/* ? <th style={{ textAlign: "center" }}>Cycle No</th> */}

                      {this.state.selectedCategory === "current_new" && (
                        <>
                          <th>Previous Cycle (Paid)</th>
                          <th>New Cycle (Unpaid)</th>
                        </>
                      )}

                      {this.state.selectedCategory === "old_new" && (
                        <>
                          <th>Old Cycle (Paid)</th>
                          <th>New Cycle (Unpaid)</th>
                        </>
                      )}

                      {this.state.selectedCategory === "old_current" && (
                        <>
                          <th>Old Cycle (Paid)</th>
                          <th>Previous Cycle (Unpaid)</th>
                        </>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {this.state.modalSchemes?.map((s, index) => (
                      <tr key={index}>
                        <td>{s.schemeName}</td>
                        {/* <td>{s.cycleNo || "-"}</td> */}

                        {this.state.selectedCategory === "current_new" && (
                          <>
                            <td>{s.previous}</td>
                            <td>{s.newCycle}</td>
                          </>
                        )}

                        {this.state.selectedCategory === "old_new" && (
                          <>
                            <td>{s.old}</td>
                            <td>{s.newCycle}</td>
                          </>
                        )}

                        {this.state.selectedCategory === "old_current" && (
                          <>
                            <td>{s.old}</td>
                            <td>{s.previous}</td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </ModalBody>
            </Modal>
            <Row className="justify-content-center align-item-center">
              {/* <p>
                <strong>Note:</strong> Payment Status is displayed in red if the
                payment is not verified, and green if verified
              </p> */}

              <Col lg="12">
                {" "}
                {/* <p>
                  <strong>Note:</strong> Click on Scheme Number to get detail of
                  each participants payments
                </p> */}
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.feedbackListColumns}
                      data={filteredData}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={this.state.feedbackListColumns}
                          data={filteredData}
                          search
                        >
                          {(toolkitprops) => (
                            <React.Fragment>
                              <Modal
                                isOpen={this.state.schemeModalOpen}
                                toggle={this.handleSchemeModalClose}
                                onMouseEnter={() =>
                                  clearTimeout(this.mouseExitTimeout)
                                }
                                onMouseLeave={this.handleMouseExit}
                              // className="modal-sm"
                              // size="sm"  // Change this to 'lg' or 'xl' for bigger width
                              >
                                <ModalHeader
                                  toggle={this.handleSchemeModalClose}
                                  tag="h4"
                                >
                                  Available Schemes for{" "}
                                  {this.state.hoveredParticipantName}
                                </ModalHeader>
                                <ModalBody>
                                  <ul>
                                    {this.state.hoveredSchemeNames.map(
                                      (name, index) => (
                                        <li key={index}>{name}</li>
                                      ),
                                    )}
                                  </ul>
                                </ModalBody>
                              </Modal>

                              <Row className="mb-3">
                                {/* Province Filter */}
                                <Col md={3}>
                                  <Label for="provinceFilter">Province</Label>
                                  <Select
                                    id="provinceFilter"
                                    options={[
                                      { value: "All", label: "All Provinces" },
                                      ...this.getUniqueOptions("province").map((option) => ({
                                        value: option,
                                        label: option,
                                      })),
                                    ]}
                                    value={
                                      this.state.provinceFilter
                                        ? { value: this.state.provinceFilter, label: this.state.provinceFilter }
                                        : { value: "All", label: "All Provinces" }
                                    }
                                    onChange={(selected) =>
                                      this.handleFilterChange("provinceFilter", {
                                        target: { value: selected?.value || "All" },
                                      })
                                    }
                                    isClearable
                                  />
                                </Col>

                                {/* District Filter */}
                                <Col md={3}>
                                  <Label for="districtFilter">District</Label>
                                  <Select
                                    id="districtFilter"
                                    options={[
                                      { value: "All", label: "All Districts" },
                                      ...this.getUniqueOptions("district").map((option) => ({
                                        value: option,
                                        label: option,
                                      })),
                                    ]}
                                    value={
                                      this.state.districtFilter
                                        ? { value: this.state.districtFilter, label: this.state.districtFilter }
                                        : { value: "All", label: "All Districts" }
                                    }
                                    onChange={(selected) =>
                                      this.handleFilterChange("districtFilter", {
                                        target: { value: selected?.value || "All" },
                                      })
                                    }
                                    isClearable
                                  />
                                </Col>

                                {/* City Filter */}
                                <Col md={3}>
                                  <Label for="cityFilter">City</Label>
                                  <Select
                                    id="cityFilter"
                                    options={[
                                      { value: "All", label: "All Cities" },
                                      ...this.getUniqueOptions("city").map((option) => ({
                                        value: option,
                                        label: option,
                                      })),
                                    ]}
                                    value={
                                      this.state.cityFilter
                                        ? { value: this.state.cityFilter, label: this.state.cityFilter }
                                        : null
                                    }
                                    onChange={(selected) =>
                                      this.handleFilterChange("cityFilter", {
                                        target: { value: selected?.value || "" },
                                      })
                                    }
                                    placeholder="Select City"
                                    isClearable
                                  />
                                </Col>

                                {/* EQA / Scheme Filter */}
                                <Col md={3}>
                                  <Label>EQA Program</Label>
                                  <Select
                                    options={[
                                      { value: "All", label: "All Schemes" },
                                      ...schemeOptionsFromData.map((name) => ({
                                        value: name,
                                        label: name,
                                      })),
                                    ]}
                                    value={
                                      this.state.schemeFilter
                                        ? { value: this.state.schemeFilter, label: this.state.schemeFilter }
                                        : { value: "All", label: "All Schemes" }
                                    }
                                    onChange={(selected) => {
                                      const val = selected?.value || "";
                                      this.setState(
                                        {
                                          schemeFilterSelected: !!selected,
                                          schemeFilter: val,
                                          forecastType: null,
                                        },
                                        this.checkFiltersApplied
                                      );
                                    }}
                                    isClearable
                                  />
                                </Col>
                              </Row>
                              {this.state.schemeFilterSelected && (
                                <Row>
                                  <Col md={3} className="mb-3">
                                    <Label>Category</Label>
                                    <Select
                                      value={
                                        this.state.forecastType
                                          ? {
                                            value: this.state.forecastType,
                                            label:
                                              this.state.forecastType ===
                                                "current_new"
                                                ? "Previous Paid — New Unpaid"
                                                : this.state
                                                  .forecastType ===
                                                  "old_new"
                                                  ? "Old Paid — New Unpaid"
                                                  : "Old Paid — Previous Unpaid",
                                          }
                                          : null
                                      }
                                      options={[
                                        {
                                          value: "current_new",
                                          label: "Previous Paid — New Unpaid",
                                        },
                                        {
                                          value: "old_new",
                                          label: "Old Paid — New Unpaid",
                                        },
                                        {
                                          value: "old_current",
                                          label: "Old Paid — Previous Unpaid",
                                        },
                                      ]}
                                      onChange={(selected) =>
                                        this.setState(
                                          {
                                            forecastType:
                                              selected?.value || "",
                                          },
                                          () => {
                                            this.checkFiltersApplied(); // reapply filter
                                          },
                                        )
                                      }
                                      isClearable
                                      placeholder="Select Category"
                                    />
                                  </Col>
                                </Row>
                              )}
                              <Row className="mb-4">
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      key={this.state.tableKey} // ✅ This is critical!
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={"table align-middle"}
                                      bordered={false}
                                      striped={false}
                                      headerWrapperClasses={"table-light"}
                                      responsive
                                      ref={this.node}
                                      filter={filterFactory()} // Ensure filterFactory is applied correctly
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ParticipantPayments.propTypes = {
  GetFinancialForecast: PropTypes.array,
  ongetfinancialforecast: PropTypes.func,
  ongetcyclelist: PropTypes.func,
  CycleList: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  confirmpayment: PropTypes.array,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => {
  const cycleList = state.CycleList?.CycleList || [];
  const ListDistrict = state.ListDistrict?.ListDistrict || [];
  const ListCity = state.ListCity?.ListCity || [];
  const ListProvince = state.ListProvince?.ListProvince || [];
  console.log("CycleList:", cycleList);
  console.log("ListDistrict:", ListDistrict);
  console.log("ListCity:", ListCity);
  return {
    userID: state.Account?.userID || null,
    CycleList: cycleList, // ✅ FIXED
    PaymentSchemeList: state.PaymentScheme?.PaymentSchemeList || [],
    GetFinancialForecast: state.AddPayment?.GetFinancialForecast ?? [],
    ListDistrict, // Field name matches return object
    ListCity,
    ListProvince,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ongetfinancialforecast: () => dispatch(getfinancialforecast()),
  ongetcyclelist: (id) => dispatch(getcyclelist(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ParticipantPayments);